export default __webpack_public_path__ + "static/media/fruit-1440w.5ca07e5d.png";